// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"aa7e3b4f","316":"359231e8","415":"7ad6924a","496":"20a35360"}[chunkId] + ".chunk.js";
};